import React from "react";
import "./HomeSec7.css";

const HomeSec7 = () => {
  return (
    <div className="main9">
      <div className="container-fluid main7">
        <div className="col-12 d-flex py-5"></div>
        <div className="row k7 text-center">
          <div className="col-3"></div>
          <div className="col-6">
            <span className="p-17">NEARBY SIGHTSEEING</span>

            <img className="img-117" src="./image434.webp" alt="hhh" />
          </div>
          <div className="col-3"></div>
        </div>
      </div>

      <div className="container j7 ">
        <div className="cont-17">
          <div className="cont-7 bb">
            <div class="centered">
              <p className="center1">Laxman Mandir</p>
            </div>

            <img className=" img-27" src="./f-3.png" alt="hhh" />
          </div>
          <div className="cont-7 bb ">
            <div class="centered">
              <p className="center1">Fatehpur Sikri</p>
            </div>

            <img className=" img-27" src="./f-1.png" alt="hhh" />
          </div>
          <div className="cont-7 bb ">
            <div class="centered">
              <p className="center1">Lohagarh Fort</p>{" "}
            </div>

            <img className="img-27" src="./f-2.png" alt="hhh" />
          </div>
        </div>

        <div className="cont-27">
          <div className="cont-77 cc ">
            <div class="centered">
              <p className="center1">Bharatpur Bird Sanctuary</p>
            </div>

            <img className=" img-27" src="./b 1.png" alt="hhh" />
          </div>
          <div className="cont-77 cc">
            <div class="centered">
              <p className="center1">Jawahar Burj</p>
            </div>

            <img className=" img-27" src="./f-5.png" alt="hhh" />
          </div>
        </div>
        <div className="col-12 py-2"></div>
      </div>
    </div>
  );
};

export default HomeSec7;
